import React from "react";

function Contact() {
  return (
    <div className="container mt-4">
      <h3 className="text-center mb-4">Contact Us</h3>
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <p className="text-center mb-3">
            For any questions, concerns, or suggestions, please email us at:
          </p>
          <h4 className="text-center mb-4" style={{ color: "#ff515aff" }}>
            HousingHub@gmail.com
          </h4>
        </div>
      </div>
    </div>
  );
}
export default Contact;
